import "./convocation-resignations-form.scss";
import { AppPage } from "../_common/components/app-page";
import { t } from "../_i18n";
import { Fragment, h } from "preact";
import {Card, CF, E, F} from "../_common/layout";
import { useEffect, useState } from "preact/hooks";
import Banner from "../_common/components/Banner";
import { Form as FinalForm } from "react-final-form";
import ButtonSpinner from "../_common/components/buttons/buttonSpinner/buttonSpinner";
import {FormField, UploadFile} from "../_common/forms/components/components";
import AcademicProgramSelector from "../expediente/components/academicProgramSelector";
import Loading from "../_common/components/loading/Loading";
import { useHistory } from "react-router";
import {connect, useSelector} from "react-redux";
import {
    downloadAnnex,
    getConvocationResignationsAcademicPrograms,
    sendConvocationResignations
} from "../_rx/convocation-resignations-form/actions";
import {isMobileAgent} from "../_common/common";
import {toastService} from "../_services/toast-service";
import {isItalianUser, isSpanishUser} from "../_common/utils/getLang";

function ConvocationResignationsForm ({
    getConvocationResignationsAcademicPrograms,
    convocation_resignations_academic_programs
}) {
    const history = useHistory();

    /** Local state **/
    const [loading, setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [fileInputKey, setFileInputKey] = useState(0);

    const [motivo, setMotivo] = useState("");
    const [anexoFile, setAnexoFile] = useState(null);
    const [justificanteFiles, setJustificanteFiles] = useState([]);
    const [selectedModules, setSelectedModules] = useState({});
    const [annexUrl, setAnnexUrl] = useState(null);
    const isMobile = isMobileAgent();

    const { convocationResignations, student_meta } = useSelector(state => ({
        convocationResignations: state.convocationResignations,
        student_meta: state.status.student_meta
    }));

    const hasConvocationData = convocationResignations && Object.keys(convocationResignations).length > 0;
    const isConvocationResignationsExtraordinary = hasConvocationData && convocationResignations.is_extraordinary;
    const locale = isSpanishUser(student_meta.shop_id) ? 'es' : (isItalianUser(student_meta.shop_id) ? 'it' : 'fr');

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            await getConvocationResignationsAcademicPrograms({ locale });
            setLoading(false);
        };
        loadData();
    }, []);



    /** Opciones para el selector **/
    const convocationOptions = (convocation_resignations_academic_programs || []).map(program => ({
        id: program.id,
        title: program.title,
        formative_actions: program.formative_actions
    }));

    useEffect(() => {
        if (convocationOptions.length === 0) return;

        const currentId = selectedOption?.id;
        const existingOption = convocationOptions.find(o => o.id === currentId);

        if (existingOption) return;

        setSelectedOption(convocationOptions[0]);
    }, [convocationOptions]);

    useEffect(() => {
        if (!selectedOption) return;

        const initialModules = {};
        selectedOption.formative_actions.forEach(module => {
            initialModules[module.enroll_id] = { ordinaria: false, extraordinaria: false };
        });
        setSelectedModules(initialModules);
    }, [selectedOption]);


    const loadingOptions = loading || !convocation_resignations_academic_programs;

    const handleAnexoFile = (e) => {
        setAnexoFile(e.target.files[0]);
    };

    const handleRemoveAnexoFile = () => {
        setAnexoFile(null);
    };

    const handleJustificanteFiles = (e) => {
        if(e.target.files.length > 5) {
            return toastService.showToast({ message: 'Se pueden subir máximo 5 archivos.', type: 'danger' });
        }
        setJustificanteFiles(Array.from(e.target.files));
    };

    const handleRemoveJustificanteFile = (index) => {
        setJustificanteFiles(files =>
            files.filter((_, i) => i !== index)
        );
    };

    const handleCheckboxChange = (moduleId, type, checked) => {
        setSelectedModules(prev => ({
            ...prev,
            [moduleId]: {
                ...prev[moduleId],
                [type]: checked
            }
        }));
    };

    const isModuleSelected = Object.values(selectedModules).some(
        mod => mod?.ordinaria || mod?.extraordinaria
    );

    const canSubmit =
        motivo.trim().length > 0 &&
        anexoFile !== null &&
        justificanteFiles.length > 0 &&
        isModuleSelected;

    /** Manejo del selector **/
    const handleSelectorChange = (option) => {
        if (!option || option.id === selectedOption?.id) return;
        setSelectedOption(option);
    };

    const submit = async () => {
        const academic_program_id = selectedOption.id;

        const formData = new FormData();

        Object.entries(selectedModules).forEach(([enrollId, values]) => {
            if (values.ordinaria) {
                formData.append('ordinary_resignation_enroll_ids[]', enrollId);
            }
            if (values.extraordinaria) {
                formData.append('extraordinary_resignation_enroll_ids[]', enrollId);
            }
        });

        justificanteFiles.forEach(file => formData.append('justifying_docs[]', file));
        formData.append('annex_doc', anexoFile);
        formData.append('comment', motivo);


        setUploading(true);

        try {
            await sendConvocationResignations(academic_program_id, formData);
            toastService.showToast({
                message: t("Solicitud enviada correctamente"),
                type: "info"
            });
            history.replace('/', { refreshConvocationResignations: true });
        } catch (err) {
            toastService.showToast({
                message: t("No se pudo enviar la solicitud."),
                type: "danger"
            });
        } finally {
            setUploading(false);
            selectedOption
        }
    };

    const handleDownloadAnnex = async () => {
        try {
            await downloadAnnex();
        } catch (err) {
            toastService.showToast({
                message: t("No se pudo descargar el anexo"),
                type: "danger"
            });
        }
    };

    return (
      (loading || !selectedOption ) ? (
        <p className="t-center">
            <em className="disabled-aspect-gray"> {t('Cargando')}. . . </em>
        </p> ) : (
        <AppPage
            name="convocation-resignations-form"
            back={history.goBack}
            class="max-width-980"
        >
            <F className="max-width-980 convocation-resignations-form m-top">
                <CF>
                    <Card smOnly class="p-x2-bottom">
                        {/* HEADER */}
                        <h1 className="hero m-bottom">
                            { !isConvocationResignationsExtraordinary ? t("Formulario de Solicitud de Renuncia a Convocatoria") : t("Formulario de Solicitud de Renuncia a Convocatoria Extraordinaria")}
                        </h1>

                        <p dangerouslySetInnerHTML={{__html: t("A través de este apartado, puedes solicitar la renuncia")}}></p>
                        <p class="m-top" dangerouslySetInnerHTML={{__html: t('El centro evaluará tu solicitud y te dará una respuesta')}}></p>

                        <Fragment>
                            <h2 className="m-top">
                                {t("Selección de Módulos")}
                            </h2>

                            {loadingOptions ? (
                                <Loading />
                            ) : convocationOptions?.length > 0 ? (
                                <Fragment>
                                    <div className="module-cards m-top-x2">
                                        <p className={`d-flex module-card ciclo ${convocationOptions.length > 1 ? "fullWidth" : ""}`}>
                                            <span class="font-bold m-r-half">{t('Ciclo: ')} </span>
                                            <AcademicProgramSelector
                                                academicProgramSelector={convocationOptions}
                                                fullWidth="fullWidth"
                                                onChange={handleSelectorChange}
                                            />
                                        </p>
                                    </div>
                                </Fragment>
                                ) : (
                                <Banner color="warning">
                                    {t("No hay convocatorias disponibles")}
                                </Banner>
                            )}

                            <p class="m-top">{t('Por favor, selecciona los módulos y convocatorias a los que deseas renunciar: ')}<span className="required">*</span></p>
                        </Fragment>

                        {selectedOption &&
                            <Fragment>
                                <FinalForm
                                    onSubmit={submit}
                                    render={({ handleSubmit, values }) => (
                                      <form onSubmit={handleSubmit}>
                                          {!isMobile &&
                                            <table className="convocation-table m-top-x2">
                                                <thead>
                                                <tr class="font-bold">
                                                    <th>{t('Módulo')}</th>
                                                    {!isConvocationResignationsExtraordinary && (
                                                      <th>{t('Ordinaria')}</th>
                                                    )}
                                                    <th>{t('Extraordinaria')}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {selectedOption.formative_actions.map((module, index) => (
                                                  <tr key={index}>
                                                      <td>{module.short_code.concat(": " + module.title)}</td>
                                                      {!isConvocationResignationsExtraordinary && (
                                                        <td>
                                                            <div
                                                              className={`${!module.is_ordinary_eligible ? "checkbox-tooltip disabled" : ""}`}
                                                              {...(!module.is_ordinary_eligible ? { "data-tooltip": t("No puedes renunciar a esta convocatoria") } : {})}
                                                            >
                                                                <input
                                                                  disabled={!module.is_ordinary_eligible}
                                                                  type="checkbox"
                                                                  checked={selectedModules[module.enroll_id]?.ordinaria || false}
                                                                  onChange={(e) => handleCheckboxChange(module.enroll_id, "ordinaria", e.target.checked)}
                                                                />
                                                            </div>
                                                        </td>
                                                      )}
                                                      <td>
                                                          <div
                                                            className={`${!module.is_extraordinary_eligible ? "checkbox-tooltip disabled" : ""}`}
                                                            {...(!module.is_extraordinary_eligible ? { "data-tooltip": t("No puedes renunciar a esta convocatoria") } : {})}
                                                          >
                                                              <input
                                                                type="checkbox"
                                                                checked={selectedModules[module.enroll_id]?.extraordinaria || false}
                                                                onChange={(e) => handleCheckboxChange(module.enroll_id, "extraordinaria", e.target.checked)}
                                                                disabled={!module.is_extraordinary_eligible}
                                                              />
                                                          </div>
                                                      </td>
                                                  </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                          }
                                          {isMobile && (
                                            <div className="module-cards m-top-x2">
                                                {selectedOption.formative_actions.map((module) => (
                                                  <div className="module-card" key={module.enroll_id}>
                                                      <div className="module-title">
                                                          {module.short_code}: {module.title}
                                                      </div>

                                                      <label className="checkbox-row">
                                                          <input
                                                            disabled={!module.is_ordinary_eligible}
                                                            checked={selectedModules[module.enroll_id]?.ordinaria || false}
                                                            type="checkbox"
                                                            onChange={(e) => handleCheckboxChange(module.enroll_id, "ordinaria", e.target.checked)}
                                                          />
                                                          <span>Ordinaria</span>
                                                          {!module.is_ordinary_eligible && (
                                                            <p className="checkbox-disabled-msg">
                                                                {t("(No puedes renunciar a esta convocatoria)")}
                                                            </p>
                                                          )}
                                                      </label>

                                                      <label className="checkbox-row">
                                                          <input
                                                            disabled={!module.is_extraordinary_eligible}
                                                            type="checkbox"
                                                            checked={selectedModules[module.enroll_id]?.extraordinaria || false}
                                                            onChange={(e) => handleCheckboxChange(module.enroll_id, "extraordinaria", e.target.checked)}

                                                          />
                                                          <span>Extraordinaria</span>
                                                          {!module.is_extraordinary_eligible && (
                                                            <p className="checkbox-disabled-msg">
                                                                {t("(No puedes renunciar a esta convocatoria)")}
                                                            </p>
                                                          )}
                                                      </label>
                                                  </div>
                                                ))}
                                            </div>
                                          )}

                                          <h2 className="m-top">
                                              {t("Subida de documentación")}
                                          </h2>

                                          <p>{t("Para poder cerrar y guardar el proceso deben estar adjuntos los 3 archivos solicitados.")}</p>

                                          <div className="m-top m-bottom">
                                              <label className="form-label p-bottom font-bold">
                                                  {t("Documentación justificativa")}
                                                  <span className="required">*</span>
                                                  <p class="font-12"> {t('(Máximo 5 archivos)')} </p>
                                              </label>

                                              <Fragment>
                                                  {justificanteFiles.length > 0 &&
                                                    justificanteFiles.map((file, index) => (
                                                      <E className="m-x2-bottom d-flex flex-column sm-no-flex-column" key={index}>
                                                        <span className="m-r font-color-149BAB m-bottom sm-no-m-bottom">
                                                            {file.name}
                                                        </span>

                                                          {!uploading && (
                                                            <span className="cursor-pointer font-color-soft-gray t-underline" onClick={() => handleRemoveJustificanteFile(index)}>
                                                                {t("Quitar archivo")}
                                                            </span>
                                                          )}
                                                      </E>
                                                    ))}

                                                  <UploadFile
                                                    key={`justificante-${fileInputKey}`}
                                                    required
                                                    classNameButton="btn btn-ghost m-top m-bottom t-upper"
                                                    accept=".doc,.docx,.pdf"
                                                    multiple
                                                    disabled={uploading}
                                                    onChange={(e) => handleJustificanteFiles(e)}
                                                  >
                                                    <span>
                                                        <i className="fa fa-file-upload m-r-half" />
                                                        {t("Subir documentación")}
                                                    </span>
                                                  </UploadFile>
                                              </Fragment>

                                          </div>

                                          <hr className="separator-xxs" />

                                          <div>
                                              <div class={`${isMobile ? 'flex-column width-fit-content m-x2-bottom' : 'flex-space-between flex-baseline-y'} d-flex`}>
                                                  <label className="form-label p-bottom font-bold">
                                                      {t("Anexo solicitud de renuncia")} <span
                                                    className="required">*</span>
                                                  </label>

                                                  <span className={` badge-download cursor-pointer t-underline font-color-149BAB`} onClick={handleDownloadAnnex}>
                                                    <i className="far fa-file-download m-r-half" />
                                                      {t('anexo_renuncia_convocatoria.pdf')}
                                                  </span>
                                              </div>

                                              <Fragment>
                                                  {anexoFile && (
                                                    <E className="m-x2-bottom d-flex flex-column sm-no-flex-column">
                                                        <span className="m-r font-color-149BAB m-bottom sm-no-m-bottom">
                                                            {anexoFile.name}
                                                        </span>

                                                        {!uploading && (
                                                          <span className="cursor-pointer font-color-soft-gray t-underline" onClick={handleRemoveAnexoFile}>{t("Quitar archivo")}</span>
                                                                                                )}
                                                    </E>
                                                  )}

                                                  <UploadFile
                                                    key={`anexo-${fileInputKey}`}
                                                    classNameButton="btn btn-ghost m-top m-bottom t-upper"
                                                    accept=".doc,.docx,.pdf"
                                                    required
                                                    disabled={uploading}
                                                    onChange={(e) => handleAnexoFile(e)}
                                                  > <i className="fa fa-file-upload m-r-half" />

                                                      <span>{t("Subir anexo")}</span>
                                                  </UploadFile>
                                              </Fragment>

                                          </div>

                                          <hr className="separator-xxs" />


                                          <div className="m-top">
                                              <label className="form-label font-bold">
                                                  {t("Motivo de la solicitud")} <span className="required">*</span>
                                              </label>

                                              <textarea
                                                className="form-textarea"
                                                name="motivo"
                                                value={motivo}
                                                onChange={(e) => setMotivo(e.target.value)}
                                                placeholder={t("Describa el motivo de su solicitud")}
                                                rows="8"
                                                maxLength={500}
                                                required
                                              />
                                              <div class="textarea-limit">
                                                  {motivo.length}/500
                                              </div>

                                          </div>

                                          <button
                                            className="btn btn-primary m-top-x2"
                                            type="submit"
                                            disabled={!canSubmit || uploading}
                                          >
                                              {uploading ?
                                                <Fragment>
                                                    <i className="far fa-spinner-third m-r-half" />
                                                    {t("Enviando...")}
                                                </Fragment>
                                              : <Fragment>
                                                    <i class="far fa-paper-plane m-r-half"></i>
                                                    {t("Enviar solicitud")}
                                                </Fragment>
                                              }
                                          </button>
                                      </form>
                                    )}
                                />
                            </Fragment>
                        }
                    </Card>
                </CF>
            </F>
        </AppPage>
      )
    );
}

ConvocationResignationsForm = connect(
    (state) => ({
        convocation_resignations_academic_programs: state.convocation_resignations_academic_programs
    }),
    {getConvocationResignationsAcademicPrograms}
)(ConvocationResignationsForm);

export default () => {
    return <ConvocationResignationsForm/>
}
